import * as React from "react";

export interface IFooterLogoProps {
    footerLogoUrl: string;
    footerLogoImgAlt: string;
    footerLogoImgSrc: string;
    footerLogoTitle?: string;
}

const FooterLogo: React.SFC<IFooterLogoProps> = props => (
    <div className="footer-logo">
        <a className="footer-logo__link" href={props.footerLogoUrl} title={props.footerLogoTitle}>
            <img
                className="footer-logo__img"
                src={props.footerLogoImgSrc}
                alt={props.footerLogoImgAlt}
                title={props.footerLogoTitle}
            />
        </a>
    </div>
);

export default FooterLogo;
